import prodConfig from './production.json'
import qaConfig from './qa.json'
import devConfig from './development.json'

export default window.__ENV__ === 'PRODUCTION' ? prodConfig : (window.__ENV__ === 'MASTER' ? qaConfig : devConfig)
